import { render, staticRenderFns } from "./ContactsSubMenuCalendar.vue?vue&type=template&id=854b807e&scoped=true&"
import script from "./ContactsSubMenuCalendar.vue?vue&type=script&lang=js&"
export * from "./ContactsSubMenuCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ContactsSubMenuCalendar.vue?vue&type=style&index=0&id=854b807e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854b807e",
  null
  
)

export default component.exports